import { render } from "./BFormTextarea.vue?vue&type=template&id=63e2e1bb&scoped=true&ts=true"
import script from "./BFormTextarea.vue?vue&type=script&lang=ts"
export * from "./BFormTextarea.vue?vue&type=script&lang=ts"

import "./BFormTextarea.vue?vue&type=style&index=0&id=63e2e1bb&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e2e1bb"]])

export default __exports__